module.exports = __webpack_public_path__ + "static/media/35_tn.ddf7a334.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/35_tn.jpg
// module id = 248
// module chunks = 0